import Vue from 'vue';
import VuePageTransition from 'vue-page-transition';
import { router } from './vueRouter';
import store from '../../store';

Vue.use(VuePageTransition);

router.beforeEach((to, from, next) => {
    if (from.name === 'experiences' && to.name === 'augmentations') {
        store.commit('app/SET_TRANSITION_PAGE', 'fade');
    } else if (from.name === 'augmentations' && to.name === 'augmentationDetails') {
        store.commit('app/SET_TRANSITION_PAGE', 'fade');
    } else if (from.name === 'augmentationDetails' && to.name === 'augmentations') {
        store.commit('app/SET_TRANSITION_PAGE', 'fade');
    } else if (from.name === 'augmentations' && to.name === 'experiences') {
        store.commit('app/SET_TRANSITION_PAGE', 'fade');
    } else {
        store.commit('app/SET_TRANSITION_PAGE', 'fade-in-up');
    }
    if (document.getElementById('main_box')) {
        document.getElementById('main_box').scrollTo({ top: 0, behavior: 'smooth' });
    }
    setTimeout(function () {
        next();
    }, 100);
});
